import React from 'react';
import "./css/Content.css";
import Works from "./Works";
import About from "./About";
import Contact from "./Contact";
import Blogs from "./Blogs";
import { BrowserRouter as Router, Switch, Route, NavLink } from "react-router-dom";

function Content() {
    return (
        <div className="content">
            <Router>
                <div className="content__content">
                    <div className="routing__links">
                        <NavLink exact to="/" className="pageLinks">Projects</NavLink>
                        <NavLink to="/about" activeClassName="active" className="pageLinks">About</NavLink>
                        <NavLink to="/contact" activeClassName="active" className="pageLinks">Contact</NavLink>
                        {/* <NavLink to="/blogs" activeClassName="active" className="pageLinks">Blogs</NavLink> */}
                    </div>  
                    <Switch>
                        <Route exact path="/">
                            <Works />
                        </Route>
                        <Route exact path="/about">
                            <About />
                        </Route>
                        <Route exact path="/contact">
                            <Contact />
                        </Route>
                        {/* <Route exact path="/blogs">
                            <Blogs />
                        </Route> */}
                    </Switch>
                </div>
            </Router>
        </div>
    )
}

export default Content
